module.exports = __webpack_public_path__ + "img/pic-05.f58e085a.jpg";